<template>
  <path
    d="M19 9.00024H5C4.45 9.00024 4 9.45024 4 10.0002C4 10.5502 4.45 11.0002 5 11.0002H19C19.55 11.0002 20 10.5502 20 10.0002C20 9.45024 19.55 9.00024 19 9.00024ZM5 15.0002H19C19.55 15.0002 20 14.5502 20 14.0002C20 13.4502 19.55 13.0002 19 13.0002H5C4.45 13.0002 4 13.4502 4 14.0002C4 14.5502 4.45 15.0002 5 15.0002Z"
  />
</template>
